import * as Yup from 'yup';
import { phoneCountryCodeSchema, phoneNumberSchema } from 'views/customers/validationSchema';
import {
    getEoriValidation,
    getExactLengthValidation,
    getMaxValidation,
    getRequiredMessage,
} from 'views/declarations/utils/validation-utils';

export const getOverviewValidationSchema = () =>
    Yup.object({
        customerName: Yup.string().required('Customer name is required.').nullable(),
        referenceCode: getExactLengthValidation('referenceCode', 3).required('Reference code is required.').nullable(),
        eori: getEoriValidation().required('EORI is required.').nullable(),
        tan: Yup.string().nullable(),
        deferredAccountNumber: Yup.string().nullable(),
        vatNumber: Yup.string().nullable(),
        addressLine1: Yup.string().required('Address line 1 is required.').nullable(),
        addressLine2: Yup.string().nullable(),
        country: Yup.string().required(getRequiredMessage('country')).nullable(),
        postCode: Yup.string().required(getRequiredMessage('postCode')).nullable(),
        city: Yup.string().required(getRequiredMessage('city')).nullable(),
        contactName: Yup.string().trim().nullable().required(getRequiredMessage('contactName')),
        email: Yup.string().trim().nullable().email('Email is invalid.').required(getRequiredMessage('email')),
        phoneCountryCode: phoneCountryCodeSchema(),
        phoneNumber: phoneNumberSchema(),
        dutyPayer: Yup.string().required(getRequiredMessage('dutyPayer')).nullable(),
        vatTreatment: Yup.string().required('VAT treatment is required').nullable(),
        vatExemption: Yup.boolean().nullable(),
        hasAEP5Authorization: Yup.boolean().nullable(),
        recipientName: Yup.string().nullable(),
        billingEmail: Yup.string().nullable().email('Email is invalid.'),
        thirdPartyBilling: Yup.string().nullable(),
        billingCustomerCode: Yup.string().nullable(),
        specialInstructions: getMaxValidation('specialInstructions', 999).nullable(),
    });
